import React, { useEffect, useRef, useState } from 'react'
import FormControl from '../../components/form/FormControl';
import { Button, Form } from 'react-bootstrap';
import Logo from '../../components/ui/Logo';
import Footer from '../../components/ui/Footer';
import { createSearchParams, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Timestamp, addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';

export default function CreateService() {
  const { currentUser, userRole } = useAuth();
    const serviceTitleRef = useRef();
    const serviceDescriptionRef = useRef();
    const servicePriceRef = useRef();
    const serviceDurationRef = useRef();

    const [service, setService] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const servicesCollectionName = 'Services';

    

    useEffect(() => {
      if(!currentUser){
        navigate({
          pathname: '/login',
          search: createSearchParams({
              path: location.pathname
          }).toString()
      })
      }
      if(currentUser && userRole !== 'Admin'){
          navigate('/service-management');
      }

        const getService = async () => {
          if(id){
            try{
                const docRef = doc(db, servicesCollectionName, id);
                const docSnap = await getDoc(docRef)
    
                if(docSnap.exists && (docSnap.data() !== null && docSnap.data() !== undefined)){
                  setService({id: docSnap.id, ...docSnap.data()});
                }
              }catch(error){
                  console.log("An Error Occured: ", error)
              }
          }
        }

        getService();
        console.log(id, service);
    }, [currentUser])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try{
            setError('');
            setLoading(true);
        

            if(id){
              const docRef = doc(db, servicesCollectionName, id);
              await updateDoc(docRef, {
                display_name: serviceTitleRef.current.value,
                description: serviceDescriptionRef.current.value,
                price: servicePriceRef.current.value,
                duration: serviceDurationRef.current.value,
                created_by: {},
                created_at: Timestamp.fromDate(new Date())
              })

              navigate('/service-management');

            }else{

              const { id } = await addDoc(collection(db, servicesCollectionName), {
                  display_name: serviceTitleRef.current.value,
                  description: serviceDescriptionRef.current.value,
                  price: servicePriceRef.current.value,
                  duration: serviceDurationRef.current.value,
                  created_by: {},
                  created_at: Timestamp.fromDate(new Date())
              });

              navigate('/service-management');
            }

          } catch (e) {
            console.log(e)
            setError(e.message);
          }
        setLoading(false); 
    }
  return (
    <div>
        <Header>
          <h2 className='text-center text-dark thick-font sub-header-txt-shadow'>Create Service</h2>
        </Header>
        
            <Form className='row g-3 mb-3 text-dark thick-font' onSubmit={handleSubmit}>

            <Form.Group controlId="service">
                <FormControl value={service && service.display_name} ref={serviceTitleRef} label={'Service Title'} classes ={"mb-3 col-sm-12 w-50 mx-auto"} required = {true} />
                <FormControl value={service && service.description} ref={serviceDescriptionRef} type={'textarea'} label={'Service Description'} classes ={"mb-3 col-sm-12 w-75 mx-auto"} required = {true} />
                <FormControl value={service && service.price} ref={servicePriceRef} type={'number'} label={'Service Price'} classes ={"mb-3 col-sm-12 w-25 mx-auto"} required = {true} />
                <FormControl value={service && service.duration} ref={serviceDurationRef} type={'number'} step={'0.01'} label={'Service Duration (In Hours)'} classes ={"mb-3 col-sm-12 w-25 mx-auto"} required = {true} />
            </Form.Group>
            <Button className='w-25 mt-2 mx-auto btn-lg btn-light bk-cream' type="submit">Submit Service</Button>
        </Form>
        <Footer></Footer>
    </div>
  )
}
